<div class="w-full">
    <!-- Encabezado Ciclo / Carrera -->
    <div class="w-full border border-gray-200 text-sm">
        <div class="flex w-full bg-gray-50">
            <div class="text-md px-4 py-2 font-medium w-4/8">Ciclo</div>
            <div class="text-md px-4 py-2 w-8/12">{{ carreaModel.ciclo?.descripcion || '' }}</div>
        </div>
        <div class="flex w-full bg-gray-50 border-t border-gray-200">
            <div class="text-md px-4 py-2 font-medium w-4/8">Carrera / Área</div>
            <div class="text-md px-4 py-2 w-8/12">{{ carreaModel.area || '' }}</div>
        </div>
    </div>

    <p class="mt-6 mb-4 text-sm">
        Para la contratación de docente para esta área y subárea, se quiere:
    </p>

    <!-- Tarjetas de requerimientos A, B, C -->
    <div class="grid gap-4 md:grid-cols-3">
        @for(r of requerimientos; track $index){
            <app-requerimiento-card
                [palabras]="palabrasClave"
                [requerimientos]="r">
            </app-requerimiento-card>
        }
    </div>
</div>
